import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_bank_recon_hdr_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	guid_cashbook: fromDatatype.GuidDataFieldInterface;
	guid_comp: fromDatatype.GuidDataFieldInterface;
	guid_branch: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	descr: fromDatatype.VarcharDatatypeInterface;
	date_start: fromDatatype.TimestampTzDatatypeInterface;
	date_end: fromDatatype.TimestampTzDatatypeInterface;
	amount_start_debit: fromDatatype.NumericDatatypeInterface;
	amount_start_credit: fromDatatype.NumericDatatypeInterface;
	amount_end_debit: fromDatatype.NumericDatatypeInterface;
	amount_end_credit: fromDatatype.NumericDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
	cashbook_txn_opening_bal: fromDatatype.NumericDatatypeInterface;
	cashbook_txn_closing_bal: fromDatatype.NumericDatatypeInterface;
	cash_stmt_opening_bal: fromDatatype.NumericDatatypeInterface;
	cash_stmt_closing_bal: fromDatatype.NumericDatatypeInterface;
	processing_auto_matching: boolean;
	
}


export class bl_fi_bank_recon_hdr_RowClass implements bl_fi_bank_recon_hdr_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	guid_cashbook: fromDatatype.GuidDataFieldInterface;
	guid_comp: fromDatatype.GuidDataFieldInterface;
	guid_branch: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	descr: fromDatatype.VarcharDatatypeInterface;
	date_start: fromDatatype.TimestampTzDatatypeInterface;
	date_end: fromDatatype.TimestampTzDatatypeInterface;
	amount_start_debit: fromDatatype.NumericDatatypeInterface;
	amount_start_credit: fromDatatype.NumericDatatypeInterface;
	amount_end_debit: fromDatatype.NumericDatatypeInterface;
	amount_end_credit: fromDatatype.NumericDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
	cashbook_txn_opening_bal: fromDatatype.NumericDatatypeInterface;
	cashbook_txn_closing_bal: fromDatatype.NumericDatatypeInterface;
	cash_stmt_opening_bal: fromDatatype.NumericDatatypeInterface;
	cash_stmt_closing_bal: fromDatatype.NumericDatatypeInterface;
	processing_auto_matching: boolean;

}

